define( [
	"./arr"
], function( arr ) {

"use strict";

return arr.sort;

} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/jquery@3.7.0/node_modules/jquery/src/var/sort.js
// module id = 5C2j
// module chunks = 1 2